/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Page_TitleInputs */



/**
* | output |
* | --- |
* | "Tournaments" |
*
* @param {Tournaments_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_page_title = /** @type {((inputs?: Tournaments_Page_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Page_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournois")
	if (locale === "es") return /** @type {LocalizedString} */ ("Torneos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneios")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tornei")
	return /** @type {LocalizedString} */ ("Tournaments")
});